import { useCallback, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import useWorkspaceDetails from '../../../../hooks/useWorkspaceDetails'
import { routePaths } from '../../../RootPage'
import SmartFunctionHeader from '../../components/SmartFunctionHeader'
import CompensationMatrixAnalysisSelectPanel, {
  compensationMatrixAnalysisPanels,
} from './CompensationMatrixAnalysisSelectPanel'

const CompensationMatrixAnalysisSmartFunctionDetailsPageHeader = () => {
  const navigate = useNavigate()
  const { workspaceId } = useParams()

  const { selectedWorkspace } = useWorkspaceDetails({
    workspaceId,
    preventFetch: true,
  })

  const backButtonUrl = useMemo(
    () =>
      `${routePaths.WORKSPACE_DETAILS}/${selectedWorkspace?.id}/overview/smartFunction`,
    [selectedWorkspace?.id]
  )

  const onRunChange = useCallback(
    (algorithmRunId?: string) => {
      const url = `${routePaths.WORKSPACE_SMART_FUNCTION_DETAILS_CC_FC_COMPENSATION_MATRIX_ANALYSIS}/${workspaceId}/${algorithmRunId}/${compensationMatrixAnalysisPanels.MATCHING}`
      navigate(url)
    },
    [navigate, workspaceId]
  )

  return (
    <SmartFunctionHeader
      backButtonUrl={backButtonUrl}
      totalFound={0}
      hideTotalAndSearchLine={true}
      onRunChange={onRunChange}
      hideDataSource
      secondLineStartChildren={<CompensationMatrixAnalysisSelectPanel />}
    ></SmartFunctionHeader>
  )
}

export default CompensationMatrixAnalysisSmartFunctionDetailsPageHeader
